export function ContentContainer({ className = '', ...props }) {
  return <div className={`max-w-4xl mx-auto ${className}`} {...props} />;
}
